<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Trap Data</h1>
        <div class="pull-right btn-group">
          <button
            class="pointer btn btn-lg btn-primary"
            v-on:click="form.showEdit({})"
          >
            Create New
          </button>
        </div>
        <div class="pull-right">
          <!--<button class="pointer btn btn-lg btn-primary" v-on:click="form.showEdit({})">Create New</button>-->
        </div>
      </div>
    </div>

    <div class="panel">
      <search-fields :form="form" :fields="searchFieldsList"></search-fields>

      <loading :working="form.working()"></loading>

      <div class="panel-body" v-if="!form.working()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Site</th>
                <th>Trap Name/Number</th>
                <th>Trap Set</th>
                <th>Date Processed</th>
                <th>ID Initials</th>
                <th>Mosquito Species</th>
                <th>Tested</th>
                <th>Work Status</th>
                <th width="120"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in form.list">
                <td>{{ siteName(item.attributes.trapSite.siteId) }}</td>
                <td>{{ item.attributes.trapSite.trapNumber }}</td>
                <td>{{ item.attributes.dateTrapSet | datetime }}</td>
                <td>{{ item.attributes.dateProcessed | datetime }}</td>
                <td>{{ item.attributes.idInitials }}</td>
                <td>
                  {{ item.attributes.adultSurveillanceMosquitoes.length }}
                </td>
                <td>
                  <i
                    class="fa"
                    :class="{
                      'fa-check-square-o': item.attributes.tested,
                      'fa-square-o': !item.attributes.tested,
                    }"
                  ></i>
                </td>
                <td>{{ item.attributes.workStatus }}</td>
                <td>
                  <!--<a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})"><i class="fa fa-pencil" style="margin-right: 10px;"></i></a>-->
                  <router-link
                    :to="{
                      name: 'data-adult-surveillance-details',
                      params: { id: item.id },
                    }"
                    ><i class="fa fa-ellipsis-h" style="margin-right: 10px;"></i
                  ></router-link>
                  <router-link
                    :to="{
                      name: 'data-arboviral-details-with-as',
                      params: { id: item.id },
                    }"
                    ><i
                      class="fa fa-file-o mr-10"
                      title="Add Arboviral Data"
                    ></i
                  ></router-link>
                  <a
                    class="pointer text-danger"
                    v-on:click="form.destroy(item.id)"
                    ><i class="fa fa-times"></i
                  ></a>
                </td>
              </tr>
            </tbody>
            <pager :form="form"></pager>
          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>
  </div>
</template>

<script>
import AdultSurveillancesServices from '@/services/AdultSurveillancesServices';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import siteForm from '@/components/forms/adult_surveillance';
import pager from '@/components/forms/pager';
import searchFields from '@/components/search_fields';
import loading from '@/components/loading';

import store from '@/store';

export default {
  name: 'adult_surveillances',

  components: {
    pager,
    searchFields,
    siteForm,
    loading,
  },

  props: ['id', 'type'],

  data() {
    return {
      searchFieldsList: { site: 'Site', date: 'Date' },
      form: new Form(AdultSurveillancesServices, {
        trapSiteId: null,
        workStatus: 'Closed by office',
      }),
    };
  },

  methods: {
    siteName(id) {
      return this.$store.getters.siteNameById(id);
    },
    mosquitoName(id) {
      return this.$store.getters.mosquitoNameById(id);
    },
  },

  created() {
    if (this.$props.id == 'new') {
      window.bus.$on('item-created', () => {
        if (this.$route.path.indexOf('adult-surveillances') > -1) {
          setTimeout(() => {
            this.form.showEdit({ title: 'Enter Trap Data' });
          }, 1000);
        }
      });
    }
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getList();
      this.$store.dispatch('setSiteSearchClear');

      if (this.$props.id) {
        switch (this.$props.type) {
          case 'ts':
            this.form.data.trapSiteId = this.$props.id;
            break;
          case 's':
            this.form.showEdit({});
            this.form.siteSearch.term = this.siteName(this.$props.id);
            this.form.onSiteSearch('siteId');
            break;
          case 'create':
            break;
        }
        this.form.showEdit({ title: 'Enter Trap Data' });
      }
    });
  },
};
</script>

<style lang="scss"></style>
